import { useSelector, useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";

import InpersonTab from "../../assets/images/png/inPersonTab.png";
import VirtualTab from "../../assets/images/png/virtualTab.png";
import onlineTab from "../../assets/images/png/onlineTab.png";
import CorporateTab from "../../assets/images/png/corporateIcon.png";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const WorkoutTabs = () => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.programs.tab);
  return (
    <div className="all-tabs">
      <div className="tabs">
        <div
          className={`tab ${currentTab === CONSTANTS.TABS.IN_PERSON ? "selected" : ""}`}
          onClick={() => {
            dispatch(setTabData("inperson"));
            eventTrack("Button Click", "InPerson Workout Tab clicked From Programs Page", "Clicks");
            eventTrackGA4("InPerson Workout Tab click", "InPerson Workout Tab clicked From Programs Page", "Clicks");
          }}
        >
          <img className="tab-img" src={InpersonTab} alt="in person tab" />
          <div className="tab-name">In-Person</div>
        </div>
        <div
          className={`tab ${currentTab === CONSTANTS.TABS.VIRTUAL ? "selected" : ""}`}
          onClick={() => {
            dispatch(setTabData("virtual"));
            eventTrack("Button Click", "Virtual Workout Tab clicked From Programs Page", "Clicks");
            eventTrackGA4("Virtual Workout Tab click", "Virtual Workout Tab clicked From Programs Page", "Clicks");
          }}
        >
          <img className="tab-img" src={VirtualTab} alt="virtual tab" />
          <div className="tab-name">Virtual</div>
        </div>
        <div
          className={`tab ${currentTab === CONSTANTS.TABS.ONLINE ? "selected" : ""}`}
          onClick={() => {
            dispatch(setTabData("online"));
            eventTrack("Button Click", "Online Workout Tab clicked From Programs Page", "Clicks");
            eventTrackGA4("Online Workout Tab click", "Online Workout Tab clicked From Programs Page", "Clicks");
          }}
        >
          <img className="tab-img" src={onlineTab} alt="online tab" />
          <div className="tab-name">Online</div>
        </div>

        <div
          className={`tab ${currentTab === CONSTANTS.TABS.CORPORATE_WELLNESS ? "selected" : ""}`}
          onClick={() => {
            dispatch(setTabData("corporate_wellness"));
            eventTrack("Button Click", "Corporate Wellness Tab clicked From Programs Page", "Clicks");
            eventTrackGA4(
              "Corporate Wellness Tab click",
              "Corporate Wellness Tab clicked From Programs Page",
              "Clicks"
            );
          }}
        >
          <img className="tab-img" src={CorporateTab} alt="in person tab" />
          <div className="tab-name">Corporate Wellness </div>
        </div>
      </div>
      <div className="small-line" />
    </div>
  );
};

export default WorkoutTabs;
